/**
 * Generated runtime TestId mirror for frontend/src/components/layout/Footer.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const FooterTestIds = {
  appFooter: "app-footer",
  footerGitBranch: "footer-git-branch",
  footerGitTag: "footer-git-tag",
  footerVersion: "footer-version"
} as const;
